import React, { useEffect, useState } from "react";
import { CircularProgress, makeStyles } from "@material-ui/core";
import CardChartsLiner from './chartLiner/index'
import { useSelector } from "react-redux";
import CardNodata from './../../../../../common/cardNoData';
// import LineCHarts from './../../../../../common/charts/lineChart';
import LineCHarts from './chartLiner';
import FilterDate from './filterDate';


let useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        width: '53%',
        boxShadow: 'rgba(0, 0, 0, 0.06) 0px 0px 20px 0px',
        borderRadius: 10,
        backgroundColor: 'rbg(255,255,255)',
        padding: '45px 30px',
        minHeight: 600,
        // height: 600,
        padding: '45px 30px',
        [theme.breakpoints.down("1100")]: {
            width: '100%',
            minHeight: 'auto',
            overflow: 'auto'
        },
    },
    title: {
        fontSize: "1.125rem",
        fontWeight: 'bold',
        marginBottom: 20,
    },
    gridLoading: {
        position: 'absulote',
        top: 0,
        width: '100%',
        height: 550,
        backgroundColor: 'rgba(0,0,0,0.1)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    gridFull: {
        width: 40,
        padding: 10,
        margin: 5,
        marginLeft: 'auto',
        border: '1px solid #E3E3E3',
        borderRadius: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#E3E3E3',
        }
    },
    fullScreenGrid: {
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '100%',
        zIndex: 1000,
        boxShadow: 'rgba(0, 0, 0, 0.06) 0px 0px 20px 0px',
        borderRadius: 10,
        backgroundColor: 'white',
        padding: '45px 30px',
        minHeight: 600,
        // height: 600,
        padding: '45px 30px',
        [theme.breakpoints.down("1100")]: {
            width: '100%',
            minHeight: 'auto',
            overflow: 'auto'
        },
    }
}))

export default function Index({ }) {

    let classes = useStyles();

    const [flagFullScreen, setFlagFullScreen] = useState(false);

    const [state, setstate] = useState({
        data: [],
        keys: []
    });



    const [usedColors, setUsedColors] = useState({});
    const stateReducer = useSelector(state => state?.report_trade_detail_reducer)


    let sortedDate = (array) => {

        let reslute = array.sort(function (a, b) {
            let bb = new Date(b?.x)
            let aa = new Date(a?.x);
            return bb - aa
        });
        return reslute ? reslute : []
    }

    const generateUniqueColor = () => {

        // return '#' + Math.floor(Math.random() * 16777215).toString(16);
        let color;
        do {
            color = '#' + Math.floor(Math.random() * 16777215).toString(16);
        } while (color === '#ffffff' || color?.length <= 6);
        return color;
    };

    useEffect(() => {
        if (stateReducer?.data?.length) {

            let data = []
            let categoriData = {}

            let KeysPersian = {
                'offer_base_price': 'قیمت پایه',
                'final_weighted_average_price': 'عرضه کننده',
                'offer_volume': 'حجم',
                'minimum_price': 'پایین ترین قیمت',
                'maximum_price': 'بالاترین قیمت',
                'final_weighted_average_price': 'قیمت میانگین'
            }


            let res = stateReducer?.data?.forEach((item) => {
                let a = Object.keys(item)
                    ?.forEach((child) => {
                        let elem = item?.[child]


                        let x = item[child]?.forEach((chart) => {


                            let { manufacturer_detail, ...rest } = chart?.body
                            let listKeys = Object.keys(rest)
                            let b = listKeys?.forEach((key) => {
                                if (key !== 'trade_date') {

                                    let newColor = generateUniqueColor(usedColors);

                                    if (!newColor) {
                                        newColor = generateUniqueColor(usedColors);
                                    }

                                    setUsedColors((prev) => ({
                                        ...prev,
                                        [key + "_name_" + child]: {
                                            data: chart,
                                            color: newColor,
                                            name: `${chart.body?.manufacturer_detail?.persianName} | ${KeysPersian[key]} `
                                        }
                                    }));

                                    data.push({
                                        id: key + "_name_" + child,
                                        x: chart?.body?.[key],
                                        y: chart?.body?.['trade_date'],
                                        name: elem?.[0] ? elem?.[0]?.body?.manufacturer_detail?.persianName : child,
                                        color: newColor
                                    })



                                }
                            })
                        })
                    }
                    )
            })



            let c = data?.forEach((item) => {
                categoriData[item?.id] = {
                    id: `${item?.name} ${KeysPersian?.[item?.id?.split('_name_')?.[0]] ? "(" + KeysPersian?.[item?.id?.split('_name_')?.[0]] + ")" : ''}`,
                    color: item?.color,
                    name: item?.name,
                    data: sortedDate(
                        (categoriData?.[item?.id]?.data ? categoriData?.[item?.id]?.data : []).concat([
                            {
                                x: new Date(`${item?.y} 00:00:00`),
                                y: item?.x
                            },
                        ]))?.reverse()

                }
            })

            if (Object.keys(categoriData)?.length) {
                setstate({ data: Object.keys(categoriData)?.map((key) => categoriData[key]), keys: [] })
            }
        }

    }, [stateReducer.data]);



    return (
        // <div className={classes['root']} 
        <div className={flagFullScreen ? classes['fullScreenGrid'] : classes['root']}

        >
            <div>
                <h3 className={classes['title']}>
                    نمودار :
                </h3>
                {
                    stateReducer?.loading && (
                        <div className={classes['gridLoading']}>
                            <CircularProgress />
                        </div>
                    )
                }

                {
                    state?.data?.length !== 0 && (
                        <>
                            <FilterDate />
                            {
                                !stateReducer?.loading && (
                                    <LineCHarts
                                        data={state?.data}
                                        usedColors={usedColors}
                                    />
                                )
                            }
                            <div className={classes['gridFull']} onClick={() => setFlagFullScreen((prev) => !prev)}>
                                <img src={'/assets/images/full.svg'} alt="" />
                            </div>
                        </>
                    )
                }



                {
                    (state?.data?.length === 0 && !stateReducer?.loading) && (
                        <>


                            <CardNodata
                                text={'داده ای یافت نشد'}
                            />


                        </>
                    )
                }

            </div>
        </div>)
}
